import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Roofing } from "@/components/site/Roofing";
import { Barns } from "@/components/site/Barns";
import { Projects } from "@/components/site/Projects";
import { About } from "@/components/site/About";
import { Testimonials } from "@/components/site/Testimonials";
import { Suppliers } from "@/components/site/Suppliers";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true, anchors: { offset: -70 } });
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-[#090B0E] font-body text-white">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Roofing />
        <Barns />
        <Projects />
        <About />
        <Suppliers />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
